import { Component } from "react";
import { withStyles } from "@mui/styles";
import { compose } from "redux";
import { connect } from "react-redux";
import withAuth from "../../components/withAuth";
import FooterFixedOnScreen from "../Layout/FooterFixedOnScreen";
import Fab from "@mui/material/Fab";
import Icon from "@mui/material/Icon/Icon";
import { getCurrentFunctionName } from "../../performanceModeManager";
import FormSection from "../../components/HumanResources/FormSection";
import { canUpdateForm } from "../../redux/humanResources/humanResourcesStatusActions";
import {
    responseValueChange,
    saveQuestions,
    setExpandedSection,
    validateInterview,
} from "../../redux/humanResources/humanResourcesEditionActions";
import { withRouter } from "react-router-dom";
import { downloadInterview, getInterview, resetForm } from "../../redux/humanResources/humanResourcesActions";
import FormDocumentSection from "../../components/HumanResources/FormDocumentSection";
import { clone } from "../../utils";
import { Tooltip } from "@mui/material";

const styles = {
    root: {
        minWidth: "40px",
        fontSize: "0.5em",
    },
};

class HRForm extends Component {
    constructor(props) {
        super(props);

        if (this.props.match.params.id) props.getInterview(this.props.match.params.id, props.activeUser);
        else if (!this.props.form) this.props.history.push("/humanResources");
    }

    responseValueChange(sectionId, metaQuestion) {
        this.props.responseValueChange(sectionId, metaQuestion, this.props.sections);
    }

    handleChange = (value) => {
        let currentSectionId = this.props.expandedSectionId;

        if (currentSectionId && canUpdateForm(this.props.currentInterview, this.props.activeUser))
            this.setSectionRead(currentSectionId); //Sauvegarde de la section qui se replie

        let collapsing = value === this.props.expandedSectionId;
        this.props.setExpandedSection(collapsing ? null : value);
    };

    validate() {
        if (this.props.expandedSectionId) this.setSectionRead(this.props.expandedSectionId); //Sauvegarde de la section dépliée

        this.props.validateInterview(
            this.props.form,
            this.props.sections,
            this.props.currentInterview,
            this.props.activeUser,
            this.props.history
        );
    }

    save() {
        let questions = [];

        if (this.props.expandedSectionId) this.setSectionRead(this.props.expandedSectionId); //Sauvegarde de la section qui se replie

        clone(this.props.sections).forEach((s) => {
            if (s.id === this.props.expandedSectionId)
                s.questions.forEach((q) => {
                    q.response_lines.forEach((rl) => (rl.state = "done"));
                    q.state = "done";
                });

            questions = questions.concat(s.questions);
        });

        this.props.saveQuestions(this.props.form, this.props.sections, questions, this.props.activeUser);
    }

    setSectionRead(sectionId) {
        if (!Number.isInteger(sectionId))
            //Exclus les sections de type document annexe
            return;

        let sections = clone(this.props.sections);
        let section = sections.find((bv) => bv.id === sectionId);

        section.questions.forEach((q) => {
            q.response_lines.forEach((rl) => (rl.state = "done"));
            q.state = "done";
        });
    }

    download() {
        this.props.downloadInterview(this.props.currentInterview, this.props.activeUser);
    }

    resetForm() {
        this.props.resetForm(this.props.currentInterview, this.props.activeUser);
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        if (!this.props.form) return <div />;

        let sectionsElements = [];
        let pdfListAtStart = [];
        let pdfListAtEnd = [];

        this.props.sections.forEach((s) => {
            sectionsElements.push(
                <FormSection
                    key={s.id}
                    id={"section-" + s.id}
                    currentSectionId={s.id}
                    onClick={this.handleChange.bind(this)}
                    responseValueChange={this.responseValueChange.bind(this)}
                    save={this.save.bind(this)}
                />
            );
        });

        this.props.form.survey.pdf_list_ids.forEach(async (p) => {
            let documentSection = (
                <FormDocumentSection
                    key={p.internalId}
                    document={p}
                    internalId={p.internalId}
                    onClick={this.handleChange.bind(this)}
                />
            );

            if (p.location === "start") pdfListAtStart.push(documentSection);
            else if (p.location === "end") pdfListAtEnd.push(documentSection);
        });

        return (
            <div>
                <div className="container-with-footer">
                    {pdfListAtStart.map((p) => p)}
                    {sectionsElements.map((be) => be)}
                    {pdfListAtEnd.map((p) => p)}
                </div>
                {canUpdateForm(this.props.currentInterview, this.props.activeUser) ? (
                    <FooterFixedOnScreen>
                        <div className="row">
                            <div className="col-lg-2 col-md-2 col-sm-3 col-3">
                                <Fab onClick={this.save.bind(this)} color={"secondary"} className="div-center">
                                    <Icon>save</Icon>
                                </Fab>
                                <span className="floating-btn-text span-center">Enregistrer</span>
                            </div>
                            <div className="offset-lg-1 col-lg-2 offset-md-1 col-md-2 col-sm-3 col-3">
                                <Tooltip id="tooltip-icon" title="Import, champs pré-remplis">
                                    <div>
                                        <Fab onClick={this.resetForm.bind(this)} className="white-button div-center">
                                            <Icon>backspace</Icon>
                                        </Fab>
                                        <span className="floating-btn-text span-center">Import</span>
                                    </div>
                                </Tooltip>
                            </div>
                            <div className="offset-lg-2 col-lg-2 offset-md-2 col-md-2 col-sm-3 col-3">
                                <Fab onClick={this.download.bind(this)} color={"primary"} className="div-center">
                                    <Icon>download</Icon>
                                </Fab>
                                <span className="floating-btn-text span-center">Prévisualiser</span>
                            </div>
                            <div className="offset-lg-1 col-lg-2 offset-md-1 col-md-2 col-sm-3 col-3">
                                <div>
                                    <Fab onClick={this.validate.bind(this)} className="green-button div-center">
                                        <Icon>check</Icon>
                                    </Fab>
                                    <span className="floating-btn-text span-center">Valider</span>
                                </div>
                            </div>
                        </div>
                    </FooterFixedOnScreen>
                ) : null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        form: state.form.currentForm,
        sections: state.form.formSections,
        activeUser: state.activeUser,
        expandedSectionId: state.form.currentSectionId,
        currentInterview: state.form.currentInterview,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        responseValueChange: (sectionId, metaQuestion, sections) =>
            dispatch(responseValueChange(sectionId, metaQuestion, sections)),
        setExpandedSection: (sectionId) => dispatch(setExpandedSection(sectionId)),
        validateInterview: (form, sections, interview, user, history) =>
            dispatch(validateInterview(form, sections, interview, user, history)),
        saveQuestions: (form, sections, questions, user) => dispatch(saveQuestions(form, sections, questions, user)),
        getInterview: (id, user) => dispatch(getInterview(id, user)),
        downloadInterview: (interview, user) => dispatch(downloadInterview(interview, user)),
        resetForm: (interview, user) => dispatch(resetForm(interview, user)),
    };
};

export default compose(withRouter, withStyles(styles), withAuth, connect(mapStateToProps, mapDispatchToProps))(HRForm);
